<div class="container">
  <div class="wrapper">
    <h2>
      Conoce más acerca de los productos Digitales que AV Villas tiene para tí:
    </h2>
    <div class="line"></div>

    <div class="products">
      <div class="product">
        <picture>
          <img
            [src]="
              assetsUrl +
              '/images/cdt/illustrations/saving-tips/icon-tarjeta.svg'
            "
            alt=""
          />
        </picture>

        <h3>Tarjeta <strong>de Crédito</strong></h3>
        <div class="line"></div>

        <p>
          Pídela desde la comodidad de tu casa para comprar, viajar, realizar
          avances y mucho más.
        </p>

        <ul>
          <li>
            <strong>Cuota de manejo gratis de 6 meses</strong> o un año (según
            tipo de tarjeta).
          </li>
          <li>
            <strong>Acumula puntos tuplús</strong> y redímelos por viajes,
            millas, o abona dinero a tus cuentas.
          </li>
        </ul>
      </div>
      <div class="product">
        <picture>
          <img
            [src]="
              assetsUrl +
              '/images/cdt/illustrations/saving-tips/icon-account.svg'
            "
            alt=""
          />
        </picture>

        <h3>Cuenta <strong>Digital</strong></h3>
        <div class="line"></div>

        <p>
          Abre tu cuenta en avvillas.com.co y empieza a realizar transacciones
          digitales sin costo y mucho más.
        </p>

        <ul>
          <li>
            <strong>Recibe la tarjeta débito en</strong> la comodidad de tu
            casa.
          </li>
          <li>
            <strong>Compra por internet</strong> y paga tus apps favoritas de
            juegos, series y música.
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="lottie-animation">
    <img
      [src]="assetsUrl + '/common/gifs/saving-tips.gif'"
      alt="animacion cargando"
      class="lottie-player"
      *ngIf="disableButton"
    />
  </div>

  <div class="button-container">
    <button
      class="btn btn-degraded blue"
      (click)="redirect()"
      id="savingTipsButton"
      [disabled]="disableButton"
    >
      Continuar
    </button>
  </div>
</div>
